export default function Profile() {
    return <h2 className="text-xl">Perfil de Usuario</h2>;
}
  